module.exports = __webpack_public_path__ + "lp/img/blur_icn-off.3ef65387.svg";